import script from "./Rafiki360Page.vue?vue&type=script&setup=true&lang=js"
export * from "./Rafiki360Page.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__